import { View } from 'foundations-components/components/View';
import CertificationsOverview from '../components/overview/CertificationsOverview';
import HorizontalContainer from '../../../components/Layouts/HorizontalContainer';
import TeamMembersOverview from '../components/overview/TeamMembersOverview';
import UsageTracker from '../../../utils/UsageTracker';
import { MY_TEAM_URL_FRAGMENT, PAGE_NAMES } from '../../../constants/Navigation';
import { useEffect } from 'react';
import { Redirect } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const RedirectToMyTeamOverview = () => {
  const location = useLocation();
  return /*#__PURE__*/_jsx(Redirect, {
    to: Object.assign({}, location, {
      pathname: MY_TEAM_URL_FRAGMENT
    })
  });
};
const MyTeamOverview = () => {
  useEffect(() => {
    UsageTracker.track('pageView', {
      screen: PAGE_NAMES.MY_TEAM
    });
  }, []);
  return /*#__PURE__*/_jsx(View, {
    backgroundColor: "fill-surface-raised",
    paddingBlock: "1000",
    children: /*#__PURE__*/_jsxs(HorizontalContainer, {
      children: [/*#__PURE__*/_jsx(CertificationsOverview, {}), /*#__PURE__*/_jsx(View, {
        marginBlockStart: "600",
        children: /*#__PURE__*/_jsx(TeamMembersOverview, {})
      })]
    })
  });
};
export default MyTeamOverview;